import bannerNS from "../../images/Banner1.svg"
import bannerCB from "../../images/Banner2.svg"
import bannerPF from "../../images/Banner3.svg"

export const banners = [
    {id: 1, src: bannerNS},
    {id: 2, src: bannerCB},
    {id: 3, src: bannerPF},
]